<template>
    <div>

        <workspace-header :providedSecondaryTitle="spotlightItem.name">
        </workspace-header>

        <div class="workspace-content">
            <div class="spotlight-detail">
                <div v-if="spotlightItem.name == ''" class="empty"></div>
                <div class="col-md-4 spotlight-detail-image" v-if="spotlightItem && spotlightItem.cover_art_url">
                    <img :src="spotlightItem.cover_art_url" onerror="javascript:this.src='/images/unknown-album.jpg'" />
                </div>

                <div class="col-md-8 spotlight-detail-text">
                    <div class="whatsOnTopRow" v-if="spotlightItem && spotlightItem.json_playlist_url">
                        <div class="spotlight-detail-title">{{ spotlightItem.name }}</div>
                        <div class="spotlight-detail-play-button" @click="playSpotlight()">
                            <font-awesome-icon icon="pause" aria-hidden="false" v-if="playerState == 'playing' && spotlightItem.json_playlist_url == playlistUrl" />
                            <font-awesome-icon icon="play" aria-hidden="false" v-else />
                        </div>
                    </div>
                    <div class="spotlight-detail-blurb" v-html="newLineToBr"></div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
  data() {
    return {
      spotlightItem: {},
      spotlightPlaylist: {},
      spotlightItems: '',
      hasPlayed: false,
    };
  },
  mounted() {
    this.fetchSpotlightItem();
  },
  methods: {
    // We need to refetch all items in order to get the selected one
    fetchSpotlightItem() {
      const self = this;
      const spotlightID = this.$route.params.id;
      this.$http.get(`/spotlight/${spotlightID}`).then((response) => {
        self.spotlightItem = response.data[0];
        self.getSpotlightPlaylist();
      },
      (response) => {
        console.log(`ERROR: ${response}`);
      });
    },
    getSpotlightPlaylist() {
      const playlistURL = this.spotlightItem.json_playlist_url;

      const self = this;
      this.$http.get(playlistURL, (data) => {
        self.spotlightPlaylist = data;
      },
      (response) => {
        console.log(`ERROR: ${response}`);
      });
    },
    playSpotlight() {
      // Hack for Safari.
      if (this.hasPlayed == false) {
        document.getElementById('playButton').click();
        this.hasPlayed = true;
      }

      const playlistURL = this.spotlightItem.json_playlist_url;

      if (this.playlistUrl == playlistURL) {
        this.$emit('toggleSpotlightPlayPause');
      } else {
        const self = this;
        this.$http.get(playlistURL)
          .then((response) => {
            const playlistURLAndContent = {
              url: playlistURL,
              tracks: shuffle(response.data),
              origin: `What's On: ${self.spotlightItem.name}`,
              route: `/whats-on/${self.spotlightItem.spotlight_station_id}`,
              playlist_code: self.spotlightItem.location_zone_custom_playlist_code,
            };
            self.$emit('playSpotlightStation', playlistURLAndContent);

            const event_data = {
              web_tracking_event_type_id: 4,
              page_name: `Spotlight ${self.spotlightItem.name}`,
            };
            self.$emit('logEvent', event_data);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    coverArtSource(url) {
      if (url == null) {
        return '/images/unknown-album.jpg';
      }

      return url;
    },
  },
  computed: {
    playButtonText() {
      let buttonText = 'PLAY';
      if (this.playerState == 'playing') {
        buttonText = 'PAUSE';
      } else if (this.playerState == 'paused') {
        buttonText = 'PLAY';
      } else if (this.playerState == 'error') {
        buttonText = 'ERROR';
      } else if (this.playerState == 'buffering') {
        buttonText = 'LOADING';
      } else {
        buttonText = 'PLAY';
      }
      return buttonText;
    },
    trackInfoText() {
      let textToReturn = '';
      if (this.currentTrackInfo) {
        textToReturn = `Now Playing: ${this.currentTrackInfo.sources[0].title} by ${this.currentTrackInfo.sources[0].artist}`;
      }

      return textToReturn;
    },
    newLineToBr() {
      if (!this.spotlightItem.details || !this.spotlightItem) {
        return '';
      }

      const withBr = this.spotlightItem.details.replace(new RegExp('\r?\n', 'g'), '<br />');
      return withBr;
    },
  },
  watch: {
    /**
         * If change view via player, need to way to update page.
         *
         * @param
         * @return
         */
    $route() {
      const spotlightID = this.$route.params.id;
      if (spotlightID) {
        for (let i = 0; i < this.spotlightItems.length; i++) {
          const item = this.spotlightItems[i];
          if (item.spotlight_station_id == spotlightID) {
            this.spotlightItem = item;

            this.getSpotlightPlaylist();
          }
        }
      }
    },
  },
  props: ['player-state', 'playlist-url', 'current-track-info'],
};

function shuffle(a) {
  let j; let x; let
    i;
  for (i = a.length; i; i--) {
    j = Math.floor(Math.random() * i);
    x = a[i - 1];
    a[i - 1] = a[j];
    a[j] = x;
  }

  return a;
}
</script>

<style scoped>
.spotlight-detail {
    min-height: 320px;
}

.spotlight-detail img {
    width: 260px;
    height: 260px;
    margin-bottom: 20px;
    /*    cursor: pointer;*/
    border: 1px solid black;
    z-index: 1;
    position: absolute;
    top: 0px;
    left: 0px;
}

.spotlight-detail span {
    /*    position: relative;
    top:-185px;
    left:90px;*/
    opacity: 1;
    cursor: pointer;
    z-index: 2;
    position: absolute;
    top: 100px;
    left: 100px;
}

.spotlight-detail:hover span {
    opacity: 1;
}

.spotlight-play-button {
    transition: .3s;
}

.spotlight-detail-subtitle {
    font-size: 15px;
}

.spotlight-detail-title {
    font-size: 20px;
    float: left;
}

.spotlight-detail-blurb {
    padding-top: 10px;
    font-size: 15px;
    text-align: left;
    padding-bottom: 20px;
    clear: both;
}

.spotlight-detail-image {
    min-width: 260px;
}

.spotlight-detail-image span {
    border: 3px solid #fff;
    padding: 12px 10px 18px 25px;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    margin-left: -15px;
    margin-top: -15px;
}

.spotlight-detail-play-button {
    float: left;
    width: 30px;
    height: 30px;
    cursor: pointer;
    margin-left: 15px;
    margin-top: 0px;
    text-align: center;
    color: #fff;
    opacity: .7;
    transition: .3s;
    font-size:20px;
    /*    border:1px solid #efefef;
    border-radius: 50%;*/
}

.spotlight-detail-play-button:hover {
    opacity: 1;
}

.spotlight-track-detail {
    font-style: italic;
    clear: left;
    width: 300px;
}

.whatsOnTopRow {
    width: 100%;
    clear: right;
}

.play-icon {
    color: #3F3E3F;
    opacity: .7;
}

.nudge-icon {
    padding-left: 5px;
}

@media (max-width:1400px) and (min-width:768px) {
    .spotlight-detail-text {
        margin-left: 280px;
    }
    .spotlight-detail-blurb {
        width: 440px;
    }
}

@media (max-width:768px) {
    .spotlight-detail {
        width: 100%;
        margin: 0 auto;
    }
    .spotlight-detail span {
        opacity: 1;
        left: 135px;
        top: 120px;
    }
    .spotlight-detail img {
        position: relative;
        top: 20px;
    }
    .spotlight-detail-image img {
        margin: 0 auto;
    }
    .spotlight-detail-text {
        padding-top: 50px;
        clear: both;
        text-align: center;
    }
}
</style>
